export default __webpack_public_path__ + "static/media/animated-paths-logo.6737331b.gif";